/* eslint-disable */

//
import React from "react"
import PropTypes from "prop-types"
import {
    datePickerGenericFilter,
    enumRegulationGlobalStatusFilter,
    enumSingleGenericFilter,
    enumOrderSort,
    enumValueSort,
    textGenericFilter,
} from "shared/search/containers/Filter/Filters"
import {
    enumGenericFilter,
    searchifySelectGenericFilter,
    toggleGenericFilter,
} from "shared/search/containers/Filter/FilterCreators"

import {
    AgencySearchifyFLV,
    DocketFilterableListView,
    PublicOrganizationFilterableListView,
    TrackingDashboardFilterableListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    AgencySelect,
    DocketSelect,
    PublicOrganizationSelect,
    TrackingDashboardSelect,
} from "app/static/frontend/selects/containers/PieSelect"

import {
    RegulationStatusSelect,
    DateListNoFutureSelect,
    genericEnumSelect,
} from "app/static/frontend/selects/containers/EnumSelect"

import { federalRegions } from "shared/imports/regionConstants"

import { getRegulationGlobalRegionOptions } from "shared/selects/helperFunctions"


const defaultPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,

    dataTypeLabel: PropTypes.string,
    helpText: PropTypes.string,
    invisible: PropTypes.bool,
    selectComponent: PropTypes.func,
    regions: PropTypes.array,
    placeholderText: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}

const defaultEnumPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,

    enumItems: PropTypes.array,
    helpText: PropTypes.string,
    sortBy: PropTypes.func,
}

const dateDefaultPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,

    noFuture: PropTypes.bool,
}

/** Status */
export const GlobalStatusFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
GlobalStatusFilter.propTypes = defaultEnumPropTypes
GlobalStatusFilter.defaultProps = {
    filterComponent: enumRegulationGlobalStatusFilter,
    uniqueFilterId: "globalStatusFilter",
    filterKey: "general_status__in",
    enumItems: [
        DjangIO.app.reg.types.GeneralRegStatus.global_proposed,
        DjangIO.app.reg.types.GeneralRegStatus.global_adopted,
    ],
    sortBy: enumValueSort,
}

export const GeneralStatusFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
GeneralStatusFilter.propTypes = defaultEnumPropTypes
GeneralStatusFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "generalStatusFilter",
    filterKey: "general_status__in",
    enumItems: DjangIO.app.reg.types.GeneralRegStatus.region_supported_items(),
    sortBy: enumValueSort,
    displayLabel: "General Regulation Status",
}

export const DetailedStatusFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
const DetailedStatusExclude = [
    DjangIO.app.reg.types.DetailedRegStatus.oira_prerule_review.value,
    DjangIO.app.reg.types.DetailedRegStatus.oira_proposal_review.value,
    DjangIO.app.reg.types.DetailedRegStatus.oira_final_review.value,
]

DetailedStatusFilter.propTypes = defaultEnumPropTypes
DetailedStatusFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "detailedStatusFilter",
    filterKey: "detailed_status__in",
    enumItems: DjangIO.app.reg.types.DetailedRegStatus.region_supported_items().filter(
        (item) => !DetailedStatusExclude.includes(item.value)
    ),
    sortBy: enumValueSort,
    displayLabel: "Detailed Regulation Status",
    selectComponent: RegulationStatusSelect,
}

/** Global Region */
export const GlobalRegionFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}

GlobalRegionFilter.propTypes = defaultEnumPropTypes
GlobalRegionFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "regulationGlobalRegionFilter",
    filterKey: "for_supported_regions",
    enumItems: getRegulationGlobalRegionOptions(),
    selectComponent: genericEnumSelect,
}

/** Title */
export const RegulationTitleFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
RegulationTitleFilter.propTypes = defaultPropTypes
RegulationTitleFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "regulationTitleFilter",
    filterKey: "title_search",
    placeholderText: "Search text of Regulation title...",
    displayLabel: "Search Titles",
}

/** Description */
export const RegulationDescriptionFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
RegulationDescriptionFilter.propTypes = defaultPropTypes
RegulationDescriptionFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "regulationDescriptionFilter",
    filterKey: "description_search",
    placeholderText: "Search text of Regulation description...",
    displayLabel: "Search Descriptions",
}

/** Authority */
export const RegulationAuthorityFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
RegulationAuthorityFilter.propTypes = defaultPropTypes
RegulationAuthorityFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "regulationAuthorityFilter",
    filterKey: "authority_search",
    placeholderText: "Search text of Regulation authority statement...",
    displayLabel: "Search Authority",
    helpText:
        "A Regulation's authority is a statement prepared by the sponsoring agency " +
        "that lists the piece(s) of legislation empowering the agency to issue that rule.",
}

/** Citation */
export const RegulationCitationFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
RegulationCitationFilter.propTypes = defaultPropTypes
RegulationCitationFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "regulationCitationFilter",
    filterKey: "citation_search",
    placeholderText: "Search text of Regulation citation...",
    displayLabel: "Search Citation",
    helpText:
        "A Regulation's citation is a list of the pieces of administrative code that are " +
        "created or affected by the proposed rulemaking.",
}

/** Type */
export const TypeFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
TypeFilter.propTypes = defaultEnumPropTypes
TypeFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "typeFilter",
    filterKey: "reg_type__in",
    enumItems: DjangIO.app.reg.types.RegType.region_supported_items(),
    sortBy: enumOrderSort,
}

/** Adders */
export const RegulationAgencySourceFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={AgencySearchifyFLV} {...props} />
}
RegulationAgencySourceFilter.propTypes = defaultPropTypes
RegulationAgencySourceFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "regulationAgencySource",
    filterKey: "associated_with_agencies_sharing_enhanced_agency_name_and_region",
    dataTypeLabel: "Agencies",
    selectComponent: AgencySelect,
}

export const RegulationAgencyPublicOrgSourceFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={PublicOrganizationFilterableListView} {...props} />
}
RegulationAgencyPublicOrgSourceFilter.propTypes = defaultPropTypes
RegulationAgencyPublicOrgSourceFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "regulationAgencyPublicOrgSourceFilter",
    filterKey: "public_org_associated_with_agency",
    dataTypeLabel: "Agencies by Public Organization",
    displayLabel: "Regulations by Agency Public Organization",
    selectComponent: PublicOrganizationSelect,
    invisible: true,
}

export const RegulationDocketSourceFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={DocketFilterableListView} {...props} />
}
RegulationDocketSourceFilter.propTypes = defaultPropTypes
RegulationDocketSourceFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "regulationDocketSource",
    filterKey: "associated_with_docket",
    dataTypeLabel: "Dockets",
    selectComponent: DocketSelect,
    regions: federalRegions,
}

// created date filters
export const RegulationDateListNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || enumSingleGenericFilter
    return <FilterComponent {...props} />
}
RegulationDateListNoFutureFilter.propTypes = defaultEnumPropTypes
RegulationDateListNoFutureFilter.defaultProps = {
    filterComponent: enumSingleGenericFilter,
    uniqueFilterId: "regulationDateListNoFutureFilter",
    filterKey: "date_range",
    enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
        (item) =>
            ![
                DjangIO.app.events.models.DateRangeType.future.value,
                DjangIO.app.events.models.DateRangeType.next_month.value,
                DjangIO.app.events.models.DateRangeType.next_week.value,
            ].includes(item.value)
    ),
    sortBy: enumOrderSort,
    displayLabel: "Date Created",
    helpText: "Filter for results that were added to Quorum after a particular date or within a specific date range.",
    selectComponent: DateListNoFutureSelect,
}

export const RegulationDatePickerStartNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationDatePickerStartNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationDatePickerStartNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationDateStartNoFuture",
    filterKey: "created__gt",
    displayLabel: "Start Date",
    noFuture: true,
    helpText: "Regulations created after date selected. Excludes date selected.",
}

export const RegulationDatePickerEndNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationDatePickerEndNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationDatePickerEndNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationDateEndNoFuture",
    filterKey: "created__lt",
    displayLabel: "End Date",
    noFuture: true,
    helpText: "Regulations created before date selected. Excludes date selected.",
}

// pre-proposal_date date filters
export const RegulationDateListPreProposedNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || enumSingleGenericFilter
    return <FilterComponent {...props} />
}
RegulationDateListPreProposedNoFutureFilter.propTypes = defaultEnumPropTypes
RegulationDateListPreProposedNoFutureFilter.defaultProps = {
    filterComponent: enumSingleGenericFilter,
    uniqueFilterId: "regulationDateListPreProposedFilter",
    filterKey: "date_range_pre_proposed",
    enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
        (item) =>
            ![
                DjangIO.app.events.models.DateRangeType.future.value,
                DjangIO.app.events.models.DateRangeType.next_month.value,
                DjangIO.app.events.models.DateRangeType.next_week.value,
            ].includes(item.value)
    ),
    sortBy: enumOrderSort,
    displayLabel: "Date Pre-Proposed",
    helpText:
        "Filter for results that took place after a particular pre-proposal date or within a specific date range.",
    selectComponent: DateListNoFutureSelect,
}

export const RegulationPreProposedDatePickerStartNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationPreProposedDatePickerStartNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationPreProposedDatePickerStartNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationPreProposedDateStartNoFuture",
    filterKey: "pre_proposal_date__gt",
    displayLabel: "Start Date",
    noFuture: true,
    helpText: "Pre-proposed after date selected. Excludes date selected.",
}

export const RegulationPreProposedDatePickerEndNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationPreProposedDatePickerEndNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationPreProposedDatePickerEndNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationPreProposedDateEndNoFuture",
    filterKey: "pre_proposal_date__lt",
    displayLabel: "End Date",
    noFuture: true,
    helpText: "Pre-proposed before date selected. Excludes date selected.",
}

// proposal_date date filters
export const RegulationDateListProposedNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || enumSingleGenericFilter
    return <FilterComponent {...props} />
}
RegulationDateListProposedNoFutureFilter.propTypes = defaultEnumPropTypes
RegulationDateListProposedNoFutureFilter.defaultProps = {
    filterComponent: enumSingleGenericFilter,
    uniqueFilterId: "regulationDateListProposedFilter",
    filterKey: "date_range_proposed",
    enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
        (item) =>
            ![
                DjangIO.app.events.models.DateRangeType.future.value,
                DjangIO.app.events.models.DateRangeType.next_month.value,
                DjangIO.app.events.models.DateRangeType.next_week.value,
            ].includes(item.value)
    ),
    sortBy: enumOrderSort,
    displayLabel: "Date Proposed",
    helpText: "Filter for results that took place after a particular proposal date or within a specific date range.",
    selectComponent: DateListNoFutureSelect,
}

export const RegulationProposedDatePickerStartNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationProposedDatePickerStartNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationProposedDatePickerStartNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationProposedDateStartNoFuture",
    filterKey: "proposal_date__gt",
    displayLabel: "Start Date",
    noFuture: true,
    helpText: "Proposed after date selected. Excludes date selected.",
}

export const RegulationProposedDatePickerEndNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationProposedDatePickerEndNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationProposedDatePickerEndNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationProposedDateEndNoFuture",
    filterKey: "proposal_date__lt",
    displayLabel: "End Date",
    noFuture: true,
    helpText: "Proposed before date selected. Excludes date selected.",
}

// comment_close_date date filters
export const RegulationDateListCommentNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || enumSingleGenericFilter
    return <FilterComponent {...props} />
}
RegulationDateListCommentNoFutureFilter.propTypes = defaultEnumPropTypes
RegulationDateListCommentNoFutureFilter.defaultProps = {
    filterComponent: enumSingleGenericFilter,
    uniqueFilterId: "regulationDateListCommentFilter",
    filterKey: "date_range_comment",
    enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items(),
    sortBy: enumOrderSort,
    displayLabel: "Date Comments Close",
    helpText:
        "Filter for results that took place after a particular comment close date " +
        "or within a specific date range.",
    selectComponent: DateListNoFutureSelect,
}

export const RegulationCommentDatePickerStartNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentDatePickerStartNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationCommentDatePickerStartNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationCommentDateStartNoFuture",
    filterKey: "comment_close_date__gt",
    displayLabel: "Start Date",
    helpText: "Comment closed after date selected. Excludes date selected.",
}

export const RegulationCommentDatePickerEndNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentDatePickerEndNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationCommentDatePickerEndNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationCommentDateEndNoFuture",
    filterKey: "comment_close_date__lt",
    displayLabel: "End Date",
    helpText: "Comment closed before date selected. Excludes date selected.",
}

// effective_date date filters
export const RegulationDateListEffectiveNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || enumSingleGenericFilter
    return <FilterComponent {...props} />
}
RegulationDateListEffectiveNoFutureFilter.propTypes = defaultEnumPropTypes
RegulationDateListEffectiveNoFutureFilter.defaultProps = {
    filterComponent: enumSingleGenericFilter,
    uniqueFilterId: "regulationDateListEffectiveFilter",
    filterKey: "date_range_effective",
    enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items(),
    sortBy: enumOrderSort,
    displayLabel: "Date Effective",
    helpText: "Filter for results that took place after a particular effective date or within a specific date range.",
    selectComponent: DateListNoFutureSelect,
}

export const RegulationEffectiveDatePickerStartNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationEffectiveDatePickerStartNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationEffectiveDatePickerStartNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationEffectiveDateStartNoFuture",
    filterKey: "effective_date__gt",
    displayLabel: "Start Date",
    helpText: "Effective after date selected. Excludes date selected.",
}

export const RegulationEffectiveDatePickerEndNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationEffectiveDatePickerEndNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationEffectiveDatePickerEndNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationEffectiveDateEndNoFuture",
    filterKey: "effective_date__lt",
    displayLabel: "End Date",
    helpText: "Effective before date selected. Excludes date selected.",
}

// expiration_date date filters
export const RegulationDateListExpirationNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || enumSingleGenericFilter
    return <FilterComponent {...props} />
}
RegulationDateListExpirationNoFutureFilter.propTypes = defaultEnumPropTypes
RegulationDateListExpirationNoFutureFilter.defaultProps = {
    filterComponent: enumSingleGenericFilter,
    uniqueFilterId: "regulationDateListExpirationFilter",
    filterKey: "date_range_expiration",
    enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items(),
    sortBy: enumOrderSort,
    displayLabel: "Date of Expiration",
    helpText: "Filter for results that took place after a particular expiration date or within a specific date range.",
    selectComponent: DateListNoFutureSelect,
}

export const RegulationExpirationDatePickerStartNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationExpirationDatePickerStartNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationExpirationDatePickerStartNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationExpirationDateStartNoFuture",
    filterKey: "expiration_date__gt",
    displayLabel: "Start Date",
    helpText: "Expiration date after date selected. Excludes date selected.",
}

export const RegulationExpirationDatePickerEndNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationExpirationDatePickerEndNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationExpirationDatePickerEndNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationExpirationDateEndNoFuture",
    filterKey: "expiration_date__lt",
    displayLabel: "End Date",
    helpText: "Expiration date before date selected. Excludes date selected.",
}

// current_status_date (last action date) filters
export const RegulationDateListCurrentStatusNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || enumSingleGenericFilter
    return <FilterComponent {...props} />
}
RegulationDateListCurrentStatusNoFutureFilter.propTypes = defaultEnumPropTypes
RegulationDateListCurrentStatusNoFutureFilter.defaultProps = {
    filterComponent: enumSingleGenericFilter,
    uniqueFilterId: "regulationDateListCurrentStatusFilter",
    filterKey: "date_range_current_status",
    enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
        (item) =>
            ![
                DjangIO.app.events.models.DateRangeType.future.value,
                DjangIO.app.events.models.DateRangeType.next_month.value,
                DjangIO.app.events.models.DateRangeType.next_week.value,
            ].includes(item.value)
    ),
    sortBy: enumOrderSort,
    displayLabel: "Date of Last Action",
    helpText: "Filter for results that took place after a particular last action date or within a specific date range.",
    selectComponent: DateListNoFutureSelect,
}

export const RegulationCurrentStatusDatePickerStartNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationCurrentStatusDatePickerStartNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationCurrentStatusDatePickerStartNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationCurrentStatusDateStartNoFuture",
    filterKey: "detailed_status_date__gt",
    displayLabel: "Start Date",
    noFuture: true,
    helpText: "Last action date after date selected. Excludes date selected.",
}

export const RegulationCurrentStatusDatePickerEndNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationCurrentStatusDatePickerEndNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationCurrentStatusDatePickerEndNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationCurrentStatusDateEndNoFuture",
    filterKey: "detailed_status_date__lt",
    displayLabel: "End Date",
    noFuture: true,
    helpText: "Last action date before date selected. Excludes date selected.",
}

export const RegulationTrackingDashboardFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={TrackingDashboardFilterableListView} {...props} />
}
RegulationTrackingDashboardFilter.propTypes = {
    filterComponent: PropTypes.func,
    uniqueFilterId: PropTypes.string,
    filterKey: PropTypes.string,
    searchifyFLV: PropTypes.string,
    searchifyPermanentFilter: PropTypes.object,
    dataTypeLabel: PropTypes.string,
    selectComponent: PropTypes.func,
}
RegulationTrackingDashboardFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "regulationTrackingDashboardFilter",
    filterKey: "for_tracking_dashboards",
    dataTypeLabel: "Tracking Dashboards",
    searchifyPermanentFilter: {
        data_type: DjangIO.app.models.QuorumDataType.regulation.value,
    },
    selectComponent: TrackingDashboardSelect,
}

export const RegulationEO12866Filter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
RegulationEO12866Filter.propTypes = defaultPropTypes
RegulationEO12866Filter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "regulationEO12866Filter",
    filterKey: "is_eo_12866_significant",
    displayLabel: "EO 12866 Designation",
    trueText: "Significant",
    falseText: "Not Significant",
    regions: federalRegions,
    helpText:
        "Executive Order 12866 (“Regulatory Planning and Review”) requires benefit-cost analysis for any new federal regulation that is " +
        "“economically significant” (having “an annual effect on the economy of $100 million or more or adversely affect[ing] " +
        "in a material way the economy, a sector of the economy, productivity, competition, [or] jobs”) " +
        "or which creates an inconsistency with other law.",
}

export const RegulationEO13771Filter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
RegulationEO13771Filter.propTypes = defaultEnumPropTypes
RegulationEO13771Filter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "regulationEO13771Filter",
    filterKey: "eo_13771_designation__in",
    enumItems: DjangIO.app.reg.types.RegEO13771Type.region_supported_items(),
    sortBy: enumValueSort,
    displayLabel: "EO 13771 Designation",
    regions: federalRegions,
    helpText:
        "Executive Order 13771 (“Reducing Regulation and Controlling Regulatory Costs”) " +
        "directs federal agencies to repeal two existing regulations for every new regulation, " +
        "and to do so in such a way that the total cost of regulations does not increase.",
}

export const RegulationProposalYearFilter = (props) => {
    const FilterComponent = props.filterComponent
    return <FilterComponent {...props} />
}
RegulationProposalYearFilter.propTypes = defaultPropTypes
RegulationProposalYearFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "RegulationProposalYearFilter",
    filterKey: "proposal_year",
    invisible: true,
}
/* eslint-enable */
